import { Col, Container, Row } from "react-bootstrap";

import BiggyImage from "../../assets/biggy_error.png";

import "./connectWalletStyles.css";

const ConnectWallet = ({ setDisplayModal }) => {
  return (
    <Container className="connect-wallet-container">
      <Row className="connect-wallet-row align-items-center mx-auto">
        <Col xs={6} className="text-center">
          <img className="connect-wallet-biggy" src={BiggyImage} alt="Biggy" />
        </Col>
        <Col xs={6} className="text-center">
          <Row xs={12}>
            <p className="connect-wallet-text">
              Connect your wallet to display your GEOPOLY's NFTs
            </p>
          </Row>
          <Row xs={2} className="center">
            <button
              className="connect-wallet-button mx-auto"
              onClick={() => setDisplayModal(true)}
            >
              Connect Wallet
            </button>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default ConnectWallet;
